import modals from './modals'

export default () => ({
  modals: modals()
})
